
import BannerTop from "~/components/home/bannerTop.vue";
import CommonTitle from "~/components/home/commonTitle.vue";
export default {
  name:"klsz",
  components: {
    CommonTitle,
    BannerTop,
    // Notice
  },
  data() {
    return {
      bannerUrl:require("@/static/images/case/banner.png"),
      imageList: [
        {
          id: 1,
          src: require(`@/static/images/case/klsz/1.png`),
          imgStyle:{
            width:"386px",
            height:"516px"
          }
        }
      ],
    }
  },
  computed: {
    contentList () {
      return this.$t('case.klsz.contentList')
    },
  },

}
